// extracted by mini-css-extract-plugin
export default {"img":"EmailUnsubscribePage_img__+6zRy","wrap":"EmailUnsubscribePage_wrap__xBHNr","content":"EmailUnsubscribePage_content__eAOWV"};